import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'

const TopicRepliesEmptyStatus = () => (
  <div className='box box__pad'>
    <div className='box__pad--s box--note'>
      <Phrase p='no.replies.box.message' />
    </div>
  </div>
)

export default TopicRepliesEmptyStatus
